(() => {
  const mobileToggle = document.querySelector("[data-vs-mobile-toggle]");
  const mobileMenu = document.querySelector("[data-vs-mobile-menu]");
  const mobileClose = document.querySelector("[data-vs-mobile-close]");

  const openMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };

  const closeMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.remove("is-open");
    document.body.style.overflow = "";
  };

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener("click", openMobileMenu);
  }

  if (mobileClose) {
    mobileClose.addEventListener("click", closeMobileMenu);
  }

  if (mobileMenu) {
    mobileMenu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", closeMobileMenu);
    });
  }

  const megaToggle = document.querySelector("[data-vs-mega-toggle]");
  const megaPanel = document.querySelector("[data-vs-mega-panel]");
  let megaCloseTimer;

  const openMegaMenu = () => {
    if (!megaPanel) return;
    if (megaCloseTimer) {
      clearTimeout(megaCloseTimer);
      megaCloseTimer = undefined;
    }
    megaPanel.classList.add("is-open");
  };

  const closeMegaMenu = () => {
    if (!megaPanel) return;
    megaPanel.classList.remove("is-open");
  };

  const scheduleMegaClose = () => {
    megaCloseTimer = setTimeout(closeMegaMenu, 120);
  };

  if (megaToggle && megaPanel) {
    megaToggle.addEventListener("mouseenter", openMegaMenu);
    megaToggle.addEventListener("click", () => {
      megaPanel.classList.toggle("is-open");
    });
    megaToggle.addEventListener("mouseleave", scheduleMegaClose);
    megaPanel.addEventListener("mouseenter", openMegaMenu);
    megaPanel.addEventListener("mouseleave", scheduleMegaClose);

    document.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Node)) return;
      if (!megaPanel.contains(target) && !megaToggle.contains(target)) {
        closeMegaMenu();
      }
    });
  }

  document.querySelectorAll("[data-vs-faq]").forEach((faq) => {
    faq.addEventListener("click", () => {
      const item = faq.closest(".vs-faq-item");
      if (!item) return;
      item.classList.toggle("is-open");
    });
  });

  document.querySelectorAll("[data-vs-filter-group]").forEach((group) => {
    const pills = group.querySelectorAll("[data-vs-filter]");
    const targetSelector = group.getAttribute("data-vs-filter-target");
    if (!targetSelector || !pills.length) return;

    const items = document.querySelectorAll(targetSelector);
    if (!items.length) return;

    pills.forEach((pill) => {
      pill.addEventListener("click", () => {
        const filter = pill.getAttribute("data-vs-filter") || "all";

        pills.forEach((node) => node.classList.remove("is-active"));
        pill.classList.add("is-active");

        items.forEach((item) => {
          const belongs = item.getAttribute("data-vs-collection");
          const shouldShow = filter === "all" || belongs === filter;
          item.classList.toggle("vs-hide", !shouldShow);
        });
      });
    });
  });
  const header = document.querySelector("[data-vs-header]");
  if (header) {
    const handleScroll = () => {
      if (window.scrollY > 12) {
        header.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
  }

  // Initialize hero sliders (simple autoplay slider for up to 5 slides)
  const initHeroSliders = () => {
    document.querySelectorAll("[data-vs-hero-slider]").forEach((slider) => {
      const slidesWrapper = slider.querySelector(".vs-hero-slides");
      const slides = slider.querySelectorAll(".vs-hero-slide");
      if (!slidesWrapper || !slides.length) return;

      let idx = 0;
      const total = slides.length;

      const show = (n) => {
        slidesWrapper.style.transform = `translateX(-${n * 100}%)`;
      };

      // start autoplay
      let interval = setInterval(() => {
        idx = (idx + 1) % total;
        show(idx);
      }, 4000);

      slider.addEventListener("mouseenter", () => {
        clearInterval(interval);
      });

      slider.addEventListener("mouseleave", () => {
        clearInterval(interval);
        interval = setInterval(() => {
          idx = (idx + 1) % total;
          show(idx);
        }, 4000);
      });
    });
  };

  document.addEventListener("DOMContentLoaded", initHeroSliders);
})();
